import { ReactNode } from "react";
import { Species } from "@spotpetinsurance/spot-types/entities/Species";

//Icons
import BillIcon from "@/shared/media/icons/policy/Bill.svg";
import BillIconRebrand from "@/shared/media/icons/policy/Bill-rebrand.svg";
import HeartHandIcon from "@/shared/media/icons/policy/Heart-Hand.svg";
import HeartHandIconRebrand from "@/shared/media/icons/policy/Heart-Hand-rebrand.svg";
import IllustratedHospital from "@/shared/media/icons/policy/Hospital.svg";
import IllustratedHospitalRebrand from "@/shared/media/icons/policy/Hospital-rebrand.svg";
import PawHeartbeat from "@/shared/media/icons/policy/Paw-Heartbeat.svg";
import PawHeartbeatRebrand from "@/shared/media/icons/policy/Paw-Heartbeat-rebrand.svg";
import DentalDisease from "@/shared/media/icons/policy/Dental-Disease.svg";
import DentalDiseaseRebrand from "@/shared/media/icons/policy/Dental-Disease-rebrand.svg";
import IllustratedLymphoma from "@/shared/media/icons/policy/Cancer.svg";
import CancerIconRebrand from "@/shared/media/icons/policy/Cancer-rebrand.svg";
import IllustratedBoneBroken from "@/shared/media/icons/policy/Bone-Broken.svg";
import CatXrayIcon from "@/shared/media/icons/policy/Cat-xray.svg";
import CatXrayIconRebrand from "@/shared/media/icons/policy/Cat-XRay-rebrand.svg";
import DogXrayIcon from "@/shared/media/icons/policy/Dog-xray.svg";
import DogXrayIconRebrand from "@/shared/media/icons/policy/Dog-Xray-rebrand.svg";
import SurgeryIcon from "@/shared/media/icons/policy/Surgery.svg";
import SurgeryIconRebrand from "@/shared/media/icons/policy/Surgery-rebrand.svg";
import PillBottleIcon from "@/shared/media/icons/policy/Pill-Bottle.svg";
import PillBottleIconRebrand from "@/shared/media/icons/policy/Pill-Bottle-rebrand.svg";
import AlternativeIcon from "@/shared/media/icons/policy/Alternative-Therapy.svg";
import AlternativeIconRebrand from "@/shared/media/icons/policy/Alternative-Therapy-rebrand.svg";
import HospitalIcon from "@/shared/media/icons/policy/Hospital.svg";
import HospitalIconRebrand from "@/shared/media/icons/policy/Hospital-rebrand.svg";
import BandaidsIcon from "@/shared/media/icons/policy/Bandaids.svg";
import BandaidsIconRebrand from "@/shared/media/icons/policy/Bandaids-rebrand.svg";
import BoneBrokenIcon from "@/shared/media/icons/policy/Bone-Broken.svg";
import BoneBrokenIconRebrand from "@/shared/media/icons/policy/Bone-broken-rebrand.svg";
import StomachIcon from "@/shared/media/icons/policy/Stomach.svg";
import StomachIconRebrand from "@/shared/media/icons/policy/Stomach-rebrand.svg";
import HipsIcon from "@/shared/media/icons/policy/Hips.svg";
import HipsIconRebrand from "@/shared/media/icons/policy/Hips-rebrand.svg";
import EarInfectionIcon from "@/shared/media/icons/policy/Ear-Infection.svg";
import DogEarInfectionIconRebrand from "@/shared/media/icons/policy/Ear-Infection-Dog-rebrand.svg";
import CatEarInfectionIconRebrand from "@/shared/media/icons/policy/Ear-Infection-Cat-rebrand.svg";
import CatEarInfectionIcon from "@/shared/media/icons/policy/Cat-Ear.svg";
import Lungs from "@/shared/media/icons/policy/Lungs.svg";
import LungsRebrand from "@/shared/media/icons/policy/Lungs-rebrand.svg";
import DogLeashIcon from "@/shared/media/icons/policy/Dog-Leash.svg";
import DogLeashIconRebrand from "@/shared/media/icons/policy/Dog-Leash-rebrand.svg";
import ParasiteIcon from "@/shared/media/icons/policy/Parasite.svg";
import ParasiteIconRebrand from "@/shared/media/icons/policy/Parasite-rebrand.svg";
import BrainTumorIcon from "@/shared/media/icons/policy/Brain-Tumor.svg";
import BrainTumorIconRebrand from "@/shared/media/icons/policy/Brain-Tumor-rebrand.svg";
import DogHeartbeatIcon from "@/shared/media/icons/policy/Dog-Heartbeat.svg";
import KidneyIllustration from "@/shared/media/icons/policy/Kidney-illustration.svg";
import KidneyIllustrationRebrand from "@/shared/media/icons/policy/Kidney-diseases-rebrand.svg";
import HeartIllustration from "@/shared/media/icons/policy/Heart-illustration.svg";
import HeartIllustrationRebrand from "@/shared/media/icons/policy/Heart-failure-rebrand.svg";
import UrinaryTractIcon from "@/shared/media/icons/policy/Urinary-tract.svg";
import UrinaryTractIconRebrand from "@/shared/media/icons/policy/Urinary-tract-infection-rebrand.svg";
import CatBack from "@/shared/media/icons/policy/Cat-Back.svg";
import CatBackRebrand from "@/shared/media/icons/policy/Cat-Back-rebrand.svg";
import CatSkinMagnifyIcon from "@/shared/media/icons/policy/Cat-Skin-Magnify.svg";
import CatSkinMagnifyIconRebrand from "@/shared/media/icons/policy/Cat-Skin-Magnify-rebrand.svg";
import AngryCat from "@/shared/media/icons/policy/Angry-Cat.svg";
import AngryCatRebrand from "@/shared/media/icons/policy/Angry-Cat-rebrand.svg";
import TapewormIcon from "@/shared/media/icons/policy/Tapeworm.svg";
import IVIcon from "@/shared/media/icons/policy/IV.svg";
import ParasitesIcon from "@/shared/media/icons/policy/Parasites.svg";
import EyeIllnessIcon from "@/shared/media/icons/policy/eye-illness.svg";
import Strings from "@/shared/utils/Strings.constants";

export interface IncludesItem {
    title: string;
    description?: string;
    affects?: AffectedBreed[];
}

export interface SectionData {
    id?: string;
    replaces?: string[]; // IDs of items this section replaces
    icon?: ReactNode;
    title: string;
    includes: IncludesItem[];
    affects?: AffectedBreed[];
}

export interface AffectedBreed {
    breedName: string;
    rate: number;
    avgClaimAmount?: number;
    claimFrequency?: number; // In the last year
    displayAs?: "percentage" | "multiplier";
}

export interface CoverageData {
    [key: string]: SectionData;
}

// Shared title for the waiting-periods exclusion. Used as the static exclusion
// title, the section heading, and the filter discriminator so a rename can't
// silently let them drift apart.
export const WAITING_PERIODS_TITLE = "Waiting Periods";

// Per-config waiting periods (e.g. Canada). When provided, it overrides the
// default static "Waiting Periods" exclusion description with a structured list.
export interface WaitingPeriods {
    intro?: string;
    items: string[];
}

export const getGeneral = (hasAccidentAndIllness: boolean, targetBreed?: string, showBreedSpecific = false, showRebrandIcon = false) => {
    const baseItems = [
        {
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.VET_EXAM.title,
            description: hasAccidentAndIllness ? Strings.PTZ_US.COVERAGE_ACCIDENT.VET_EXAM.description : "For car accidents, heatstroke, etc"
        },
        { title: Strings.PTZ_US.COVERAGE_ACCIDENT.DIAGNOSTICS.title, description: Strings.PTZ_US.COVERAGE_ACCIDENT.DIAGNOSTICS.description },
        { title: "Surgery at licensed vets or emergency pet hospitals", description: "Spot plans can be used at any vet in the US or Canada" },
        { title: Strings.PTZ_US.COVERAGE_ACCIDENT.MEDS.title, description: Strings.PTZ_US.COVERAGE_ACCIDENT.MEDS.description },
        { title: Strings.PTZ_US.COVERAGE_ACCIDENT.TREATMENTS.title, description: Strings.PTZ_US.COVERAGE_ACCIDENT.TREATMENTS.description }
    ];

    // Only add breed-specific items if we have accident+illness AND breed-specific feature is enabled
    const breedSpecificItems = [];
    if (hasAccidentAndIllness && showBreedSpecific && targetBreed) {
        const allBreedItems = [
            {
                title: Strings.PTZ_US.COVERAGE_ACCIDENT.EAR_CONDITIONS.title,
                affects: [
                    { breedName: "Golden Retriever", rate: 1.94 },
                    { breedName: "Labrador Retriever", rate: 2 },
                    { breedName: "American Shorthair", rate: 1.36 }
                ]
            },
            {
                title: Strings.PTZ_US.COVERAGE_ACCIDENT.NEURO_MUSCULAR_DISORDERS.title,
                affects: [{ breedName: "French Bulldog", rate: 4 }]
            },
            {
                title: Strings.PTZ_US.COVERAGE_ACCIDENT.RESPIRATORY_ILLNESSES.title,
                affects: [{ breedName: "French Bulldog", rate: 1.55 }]
            },
            {
                title: Strings.PTZ_US.COVERAGE_ACCIDENT.BEHAVIORAL_CONDITIONS.title,
                affects: [
                    { breedName: "Medium Mix", rate: 1.53 },
                    { breedName: "American Shorthair", rate: 1.42 },
                    { breedName: "Domestic Mediumhair", rate: 1.41 },
                    { breedName: "Domestic Longhair", rate: 1.36 }
                ]
            },
            { title: Strings.PTZ_US.COVERAGE_ACCIDENT.PARASITES.title, affects: [{ breedName: "American Shorthair", rate: 1.34 }] },
            {
                title: Strings.PTZ_US.COVERAGE_ACCIDENT.EHRLICHIA.title,
                affects: [{ breedName: "Medium Mix", rate: 2 }]
            },
            {
                title: Strings.PTZ_US.COVERAGE_ACCIDENT.BRAIN_TUMORS.title,
                affects: [{ breedName: "Medium Mix", rate: 2.27 }]
            },
            {
                title: Strings.PTZ_US.COVERAGE_ACCIDENT.HEART_MURMURS.title,
                affects: [{ breedName: "Small Mix", rate: 2 }]
            },
            { title: Strings.PTZ_US.COVERAGE_ACCIDENT.SKIN_INFECTIONS.title, affects: [{ breedName: "Domestic Shorthair", rate: 1.25 }] },
            {
                title: Strings.PTZ_US.COVERAGE_ACCIDENT.GASTROINTESTINAL_STOMACH_CONDITIONS.title,
                affects: [
                    { breedName: "Domestic Shorthair", rate: 1.24 },
                    { breedName: "Domestic Longhair", rate: 1.34 }
                ]
            },
            {
                title: Strings.PTZ_US.COVERAGE_ACCIDENT.KIDNEY_DISEASES.title,
                affects: [{ breedName: "Domestic Shorthair", rate: 1.27 }]
            },
            { title: Strings.PTZ_US.COVERAGE_ACCIDENT.ALLERGIC_DERMATITIS.title, affects: [{ breedName: "Domestic Mediumhair", rate: 1.37 }] },
            { title: Strings.PTZ_US.COVERAGE_ACCIDENT.HEART_FAILURE.title, affects: [{ breedName: "Domestic Mediumhair", rate: 1.41 }] },
            { title: Strings.PTZ_US.COVERAGE_ACCIDENT.URINARY_TRACT_INFECTIONS.title, affects: [{ breedName: "Domestic Longhair", rate: 1.36 }] },
            { title: Strings.PTZ_US.COVERAGE_ACCIDENT.LEG_INJURIES.title, affects: [{ breedName: "Mixed Cat", rate: 1.36 }] },
            { title: Strings.PTZ_US.COVERAGE_ACCIDENT.BACK_NECK_INJURIES.title, affects: [{ breedName: "Mixed Cat", rate: 1.31 }] },
            { title: Strings.PTZ_US.COVERAGE_ACCIDENT.RENAL_FAILURE.title, affects: [{ breedName: "Mixed Cat", rate: 1.36 }] }
        ];

        // Filter to only include items that affect the current breed
        const matchingBreedItems = allBreedItems.filter(item => item.affects.some(affect => targetBreed.includes(affect.breedName)));

        breedSpecificItems.push(...matchingBreedItems);
    }

    return {
        icon: showRebrandIcon ? <HeartHandIconRebrand className="size-16" /> : <HeartHandIcon className="size-16" />,
        title: Strings.COVERAGE_ACCIDENT_ONLY_HEADER,
        illnessTitle: Strings.COVERAGE_ACCIDENT_ILLNESS_HEADER,
        includes: [...baseItems, ...breedSpecificItems].filter(Boolean) // filter(Boolean) removes any falsy values
    };
};

export const getAccident = (targetBreed?: string, showBreedSpecific = false, showRebrandIcon = false) => {
    const breedSpecificItems = [];

    // Swallowed objects has no base equivalent — add it only when breed matches
    if (showBreedSpecific && targetBreed) {
        const swallowedObjects = {
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.SWALLOWED_OBJECTS.title,
            affects: [
                { breedName: "Golden Retriever", rate: 1.92 },
                { breedName: "Australian Shepherd", rate: 4.4, avgClaimAmount: 430 },
                { breedName: "Labrador Retriever", rate: 1.52 },
                { breedName: "Dachshund", rate: 1.19, displayAs: "percentage" as const },
                { breedName: "Goldendoodle", rate: 2.4, avgClaimAmount: 405 },
                { breedName: "Pit Bull", rate: 2.4 },
                { breedName: "German Shepherd", rate: 1.7, displayAs: "percentage" as const }
            ]
        };
        if (swallowedObjects.affects.some(affect => targetBreed.includes(affect.breedName))) {
            breedSpecificItems.push(swallowedObjects);
        }
    }

    // For "Cuts" and "Broken bones" — enrich the base item with affects instead of duplicating
    const cutsAffects =
        showBreedSpecific && targetBreed ? [{ breedName: "Shih Tzu", rate: 1.45, displayAs: "percentage" as const }].filter(a => targetBreed.includes(a.breedName)) : [];

    const brokenBonesAffects =
        showBreedSpecific && targetBreed
            ? [
                  { breedName: "Chihuahua", rate: 1.31, displayAs: "percentage" as const },
                  { breedName: "Pit Bull", rate: 2.4 },
                  { breedName: "Yorkshire Terrier", rate: 2, displayAs: "percentage" as const }
              ].filter(a => targetBreed.includes(a.breedName))
            : [];

    const baseItems = [
        { title: "Toxic ingestions" },
        { title: "Cuts", ...(cutsAffects.length ? { affects: cutsAffects } : {}) },
        { title: "Bite wounds" },
        { title: "Insect bites or stings" },
        { title: Strings.PTZ_US.COVERAGE_ACCIDENT.BROKEN_BONES.title, ...(brokenBonesAffects.length ? { affects: brokenBonesAffects } : {}) }
    ];

    return {
        icon: showRebrandIcon ? <IllustratedHospitalRebrand className="size-16" /> : <IllustratedHospital className="size-16" />,
        title: "Accident coverage includes:",
        includes: [...breedSpecificItems, ...baseItems]
    };
};

export const getIllnessSubSections = (iconSize = "size-12", showRebrandIcon = false): CoverageData => {
    return {
        breedSpecific: {
            icon: showRebrandIcon ? <PawHeartbeatRebrand className={iconSize} /> : <PawHeartbeat className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ILLNESS.BREED.title,
            includes: Strings.PTZ_US.COVERAGE_ILLNESS.BREED.covers
        },
        dentalIllnesses: {
            icon: showRebrandIcon ? <DentalDiseaseRebrand className={iconSize} /> : <DentalDisease className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ILLNESS.DENTAL.title,
            includes: Strings.PTZ_US.COVERAGE_ILLNESS.DENTAL.covers,
            affects: [
                { breedName: "Chihuahua", rate: 2.4 },
                { breedName: "Dachshund", rate: 2.1 },
                { breedName: "Yorkshire", rate: 3.1, avgClaimAmount: 424, claimFrequency: 1588 },
                { breedName: "Shih Tzu", rate: 2.2 }
            ]
        },
        cancer: {
            icon: showRebrandIcon ? <CancerIconRebrand className={iconSize} /> : <IllustratedLymphoma className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ILLNESS.CANCER.title,
            includes: Strings.PTZ_US.COVERAGE_ILLNESS.CANCER.covers,
            affects: [
                { breedName: "Golden Retriever", rate: 2 },
                { breedName: "Australian Shepherd", rate: 2 },
                { breedName: "Dachshund", rate: 1.27, displayAs: "percentage" },
                { breedName: "Pit Bull", rate: 2.1 },
                { breedName: "Shih Tzu", rate: 1.75, displayAs: "percentage" }
            ]
        },
        chronicConditions: {
            icon: showRebrandIcon ? <StomachIconRebrand className={iconSize} /> : <StomachIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ILLNESS.CHRONIC.title,
            includes: Strings.PTZ_US.COVERAGE_ILLNESS.CHRONIC.covers
        },
        orthopedicConditions: {
            icon: showRebrandIcon ? <BoneBrokenIconRebrand className={iconSize} /> : <IllustratedBoneBroken className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ILLNESS.ORTHOPEDIC.title,
            includes: Strings.PTZ_US.COVERAGE_ILLNESS.ORTHOPEDIC.covers,
            affects: [
                { breedName: "Chihuahua", rate: 1.5, displayAs: "percentage" },
                { breedName: "German Shepherd", rate: 1.56, displayAs: "percentage" },
                { breedName: "Dachshund", rate: 1.56, displayAs: "percentage", avgClaimAmount: 436, claimFrequency: 2452 },
                { breedName: "Pit Bull", rate: 2.2 }
            ]
        }
    };
};

//Exclusions

export const coverageExclusions = [
    {
        title: WAITING_PERIODS_TITLE,
        description: "The time period before coverage begins."
    },
    {
        title: "Pre-existing Conditions",
        description: Strings.PTZ_US.EXCLUSIONS.PRE_EXISTING_CONDITIONS
    },
    {
        title: "Cosmetic Procedures",
        description: "Our plans do not cover elective procedures, such as tail docking, ear cropping, and claw removal."
    },
    {
        title: "Breeding Costs",
        description: "Our plans do not cover costs associated with breeding or pregnancy."
    },
    {
        title: "Preventive Care",
        description:
            "Coverage for preventive care, like annual wellness exams, vaccines, and screenings, is not included in this plan. You can add preventive care coverage for a little more per month after you select your base plan."
    }
];

export const getAccidentCoverageItems = (species: Species, iconSize = "size-12", hasAccidentAndIllness: boolean, showRebrandIcon = false) => {
    const diagnosticsIcon = () => {
        if (species === Species.Dog) {
            return showRebrandIcon ? <DogXrayIconRebrand className={iconSize} /> : <DogXrayIcon className={iconSize} />;
        } else if (species === Species.Cat) {
            return showRebrandIcon ? <CatXrayIconRebrand className={iconSize} /> : <CatXrayIcon className={iconSize} />;
        }
    };
    const behavioralIcon = () => {
        if (species === Species.Dog) {
            return showRebrandIcon ? <DogLeashIconRebrand className={iconSize} /> : <DogLeashIcon className={iconSize} />;
        } else if (species === Species.Cat) {
            return showRebrandIcon ? <AngryCatRebrand className={iconSize} /> : <AngryCat className={iconSize} />;
        }
    };
    const earInfectionIcon = () => {
        if (species === Species.Dog) {
            return showRebrandIcon ? <DogEarInfectionIconRebrand className={iconSize} /> : <EarInfectionIcon className={iconSize} />;
        } else if (species === Species.Cat) {
            return showRebrandIcon ? <CatEarInfectionIconRebrand className={iconSize} /> : <CatEarInfectionIcon className={iconSize} />;
        }
    };

    return [
        // Default items (everyone sees these unless replaced)
        {
            id: "vet-exam",
            icon: showRebrandIcon ? <BillIconRebrand className={iconSize} /> : <BillIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.VET_EXAM.title,
            description: hasAccidentAndIllness ? Strings.PTZ_US.COVERAGE_ACCIDENT.VET_EXAM.description : Strings.PTZ_US.COVERAGE_ACCIDENT.VET_EXAM.accidentOnlydescription
        },
        {
            id: "diagnostics",
            icon: diagnosticsIcon(),
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.DIAGNOSTICS.title,
            description: Strings.PTZ_US.COVERAGE_ACCIDENT.DIAGNOSTICS.description
        },
        {
            id: "surgery",
            icon: showRebrandIcon ? <SurgeryIconRebrand className={iconSize} /> : <SurgeryIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.SURGERY.title,
            description: Strings.PTZ_US.COVERAGE_ACCIDENT.SURGERY.description
        },
        {
            id: "meds",
            icon: showRebrandIcon ? <PillBottleIconRebrand className={iconSize} /> : <PillBottleIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.MEDS.title,
            description: Strings.PTZ_US.COVERAGE_ACCIDENT.MEDS.description
        },
        {
            id: "treatments",
            icon: showRebrandIcon ? <AlternativeIconRebrand className={iconSize} /> : <AlternativeIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.TREATMENTS.title,
            description: Strings.PTZ_US.COVERAGE_ACCIDENT.TREATMENTS.description
        },
        {
            id: "swallowed-objects",
            icon: showRebrandIcon ? <HospitalIconRebrand className={iconSize} /> : <HospitalIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.SWALLOWED_OBJECTS.title,
            affects: [
                { breedName: "Golden Retriever", rate: 1.92, avgClaimAmount: 1834 },
                { breedName: "Labrador Retriever", rate: 1.52, avgClaimAmount: 1850 },
                { breedName: "Australian Shepherd", rate: 4.4, avgClaimAmount: 430 },
                { breedName: "Dachshund", rate: 1.19, displayAs: "percentage", avgClaimAmount: 436 },
                { breedName: "Goldendoodle", rate: 2.4, avgClaimAmount: 405 },
                { breedName: "German Shepherd", rate: 1.7, displayAs: "percentage", avgClaimAmount: 470 },
                { breedName: "Pit Bull", rate: 2.4, avgClaimAmount: 503 }
            ]
        },
        {
            id: "cuts-wounds",
            icon: showRebrandIcon ? <BandaidsIconRebrand className={iconSize} /> : <BandaidsIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.CUTS_WOUNDS.title,
            affects: [{ breedName: "Shih Tzu", rate: 1.45, displayAs: "percentage", avgClaimAmount: 378 }]
        },
        {
            id: "broken-bones",
            icon: showRebrandIcon ? <BoneBrokenIconRebrand className={iconSize} /> : <BoneBrokenIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.BROKEN_BONES.title,
            affects: [
                { breedName: "Pit Bull", rate: 1.75, displayAs: "percentage", avgClaimAmount: 503 },
                { breedName: "Chihuahua", rate: 1.31, displayAs: "percentage", avgClaimAmount: 438 },
                { breedName: "Yorkshire", rate: 1.2, displayAs: "percentage", avgClaimAmount: 424 }
            ]
        },

        // Breed-specific items (only show to matching breeds, may replace defaults)

        // done to obtain behavior required in Figma, not a mistake
        {
            id: "swallowed-objects",
            icon: showRebrandIcon ? <HospitalIconRebrand className={iconSize} /> : <HospitalIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.SWALLOWED_OBJECTS.title,
            affects: [{ breedName: "Goldendoodle", rate: 2.4, avgClaimAmount: 405, claimFrequency: 2671 }],
            replaces: ["swallowed-objects"]
        },
        ////////
        {
            id: "respiratory-illnesses",
            icon: showRebrandIcon ? <LungsRebrand className={iconSize} /> : <Lungs className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.RESPIRATORY_ILLNESSES.title,
            affects: [
                { breedName: "Goldendoodle", rate: 1.4, displayAs: "percentage" },
                { breedName: "Yorkshire", rate: 1.68, displayAs: "percentage" }
            ],
            replaces: ["broken-bones"]
        },
        {
            id: "eye-conditions",
            icon: <EyeIllnessIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.EYE_CONDITIONS.title,
            affects: [
                { breedName: "Yorkshire", rate: 2.4 },
                { breedName: "Shih Tzu", rate: 2.4, avgClaimAmount: 378, claimFrequency: 2076 }
            ],
            replaces: ["cuts-wounds"]
        },
        {
            id: "blood-disorders",
            icon: <IVIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.BLOOD_DISORDERS.title,
            affects: [{ breedName: "Dachshund", rate: 1.37, displayAs: "percentage" }],
            replaces: ["cuts-wounds"]
        },
        {
            id: "rectal-conditions",
            icon: <TapewormIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.RECTAL_CONDITIONS.title,
            affects: [{ breedName: "German Shepherd", rate: 1.72, displayAs: "percentage" }],
            replaces: ["cuts-wounds"]
        },
        {
            id: "stomach-conditions",
            icon: <StomachIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.GASTROINTESTINAL_STOMACH_CONDITIONS.title,
            affects: [
                { breedName: "German Shepherd", rate: 2.1, avgClaimAmount: 470, claimFrequency: 5534 },
                { breedName: "Goldendoodle", rate: 1.6, displayAs: "percentage" },
                { breedName: "Australian Shepherd", rate: 1.64, avgClaimAmount: 430, claimFrequency: 2071 }
            ],
            replaces: ["treatments"]
        },
        {
            id: "heart-conditions",
            icon: <HeartHandIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.HEART_CONDITIONS.title,
            affects: [
                { breedName: "Chihuahua", rate: 4.6, avgClaimAmount: 438, claimFrequency: 872 },
                { breedName: "Dachshund", rate: 1.37, displayAs: "percentage" },
                { breedName: "Yorkshire", rate: 1.81, displayAs: "percentage" },
                { breedName: "Shih Tzu", rate: 1.81, displayAs: "percentage" }
            ],
            replaces: ["treatments"]
        },
        {
            id: "infectious-diseases",
            icon: <ParasitesIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.INFECTIOUS_DISEASES.title,
            affects: [{ breedName: "Pit Bull", rate: 1.75, displayAs: "percentage" }],
            replaces: ["treatments"]
        },
        {
            id: "ear-conditions",
            icon: earInfectionIcon(),
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.EAR_CONDITIONS.title,
            affects: [
                { breedName: "American Shorthair", rate: 1.36, avgClaimAmount: 443, claimFrequency: 619 },
                { breedName: "Golden Retriever", rate: 1.94, avgClaimAmount: 1834, claimFrequency: 1881 },
                { breedName: "Labrador Retriever", rate: 2, avgClaimAmount: 1850, claimFrequency: 1714 },
                { breedName: "Goldendoodle", rate: 1.68, displayAs: "percentage" },
                { breedName: "Pit Bull", rate: 2, avgClaimAmount: 503, claimFrequency: 600 }
            ],
            replaces: ["cuts-wounds"]
        },
        {
            id: "neuro-muscular-disorders",
            icon: showRebrandIcon ? <HipsIconRebrand className={iconSize} /> : <HipsIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.NEURO_MUSCULAR_DISORDERS.title,
            affects: [{ breedName: "French Bulldog", rate: 4 }],
            replaces: ["broken-bones"]
        },
        {
            id: "respiratory-illnesses",
            icon: showRebrandIcon ? <LungsRebrand className={iconSize} /> : <Lungs className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.RESPIRATORY_ILLNESSES.title,
            affects: [
                { breedName: "French Bulldog", rate: 1.55 },
                { breedName: "Australian Shepherd", rate: 2 },
                { breedName: "Chihuahua", rate: 3.3 }
            ],
            replaces: ["cuts-wounds"]
        },
        {
            id: "behavioral-conditions",
            icon: behavioralIcon(),
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.BEHAVIORAL_CONDITIONS.title,
            affects: [
                { breedName: "Medium Mix", rate: 1.53, avgClaimAmount: 1557, claimFrequency: 2076 },
                { breedName: "American Shorthair", rate: 1.42 },
                { breedName: "Domestic Mediumhair", rate: 1.41, avgClaimAmount: 445, claimFrequency: 286 },
                { breedName: "Domestic Longhair", rate: 1.36 }
            ],
            replaces: ["swallowed-objects"]
        },
        {
            id: "ehrlichia",
            icon: showRebrandIcon ? <ParasiteIconRebrand className={iconSize} /> : <ParasiteIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.EHRLICHIA.title,
            affects: [{ breedName: "Medium Mix", rate: 2 }],
            replaces: ["cuts-wounds"]
        },
        {
            id: "brain-tumors",
            icon: showRebrandIcon ? <BrainTumorIconRebrand className={iconSize} /> : <BrainTumorIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.BRAIN_TUMORS.title,
            affects: [{ breedName: "Medium Mix", rate: 2.27, displayAs: "percentage" }],
            replaces: ["broken-bones"]
        },
        {
            id: "heart-murmurs",
            icon: <DogHeartbeatIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.HEART_MURMURS.title,
            affects: [{ breedName: "Small Mix", rate: 2 }],
            replaces: ["cuts-wounds"]
        },
        {
            id: "parasites",
            icon: showRebrandIcon ? <ParasiteIconRebrand className={iconSize} /> : <ParasiteIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.PARASITES.title,
            affects: [{ breedName: "American Shorthair", rate: 1.34 }],
            replaces: ["broken-bones"]
        },
        {
            id: "skin-infections",
            icon: showRebrandIcon ? <CatSkinMagnifyIconRebrand className={iconSize} /> : <CatSkinMagnifyIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.SKIN_INFECTIONS.title,
            affects: [{ breedName: "Domestic Shorthair", rate: 1.25 }],
            replaces: ["cuts-wounds"]
        },
        {
            id: "stomach-conditions",
            icon: showRebrandIcon ? <StomachIconRebrand className={iconSize} /> : <StomachIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.GASTROINTESTINAL_STOMACH_CONDITIONS.title,
            affects: [
                { breedName: "Domestic Shorthair", rate: 1.24, avgClaimAmount: 1912, claimFrequency: 4857 },
                { breedName: "Domestic Longhair", rate: 1.34, avgClaimAmount: 449, claimFrequency: 768 }
            ],
            replaces: ["broken-bones"]
        },
        {
            id: "kidney-diseases",
            icon: showRebrandIcon ? <KidneyIllustrationRebrand className={iconSize} /> : <KidneyIllustration className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.KIDNEY_DISEASES.title,
            affects: [{ breedName: "Domestic Shorthair", rate: 1.27 }],
            replaces: ["swallowed-objects"]
        },
        {
            id: "allergic-dermatitis",
            icon: showRebrandIcon ? <CatSkinMagnifyIconRebrand className={iconSize} /> : <CatSkinMagnifyIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.ALLERGIC_DERMATITIS.title,
            affects: [{ breedName: "Domestic Mediumhair", rate: 1.37 }],
            replaces: ["cuts-wounds"]
        },
        {
            id: "heart-failure",
            icon: showRebrandIcon ? <HeartIllustrationRebrand className={iconSize} /> : <HeartIllustration className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.HEART_FAILURE.title,
            affects: [{ breedName: "Domestic Mediumhair", rate: 1.41 }],
            replaces: ["broken-bones"]
        },
        {
            id: "urinary-tract-infections",
            icon: showRebrandIcon ? <UrinaryTractIconRebrand className={iconSize} /> : <UrinaryTractIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.URINARY_TRACT_INFECTIONS.title,
            affects: [{ breedName: "Domestic Longhair", rate: 1.36 }],
            replaces: ["cuts-wounds"]
        },
        {
            id: "leg-injuries",
            icon: showRebrandIcon ? <BoneBrokenIconRebrand className={iconSize} /> : <BoneBrokenIcon className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.LEG_INJURIES.title,
            affects: [{ breedName: "Mixed Cat", rate: 1.36, avgClaimAmount: 417 }],
            replaces: ["broken-bones"]
        },
        {
            id: "back-neck-injuries",
            icon: showRebrandIcon ? <CatBackRebrand className={iconSize} /> : <CatBack className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.BACK_NECK_INJURIES.title,
            affects: [{ breedName: "Mixed Cat", rate: 1.31 }],
            replaces: ["cuts-wounds"]
        },
        {
            id: "renal-failure",
            icon: showRebrandIcon ? <KidneyIllustrationRebrand className={iconSize} /> : <KidneyIllustration className={iconSize} />,
            title: Strings.PTZ_US.COVERAGE_ACCIDENT.RENAL_FAILURE.title,
            affects: [{ breedName: "Mixed Cat", rate: 1.36 }],
            replaces: ["swallowed-objects"]
        }
    ];
};
